export type IAppointmentDetail = {
  appointmentId: string
  id: string
  serviceType: string
  appointmentType: string
  serviceName: string
  patientAppointmentType: PatientAppointmentType
  location: string
  centerName: string
  primaryConsultantId: string
  primaryConsultantName: string
  mocId?: string
  consultantName: string
  consultantId: string
  scheduleDate: Date
  scheduleTime: string
  comments: string
  uploads: Array<string>
  status: AppointmentStatus
  arrivalTime: Date
  engageTime: string
  completedTime: string
  channel: string
  bookingDoneBy: string
  doctorNotes: Array<string>
  diagnosticsDetails: Array<string>
  slots: Array<string>
  isSpecialRequest: boolean
  specialRequestFromTime: string
  specialRequestToTime: string
  //  MedicineInfo prescriptionDetails;
  //  TreatmentPlanInfo treatmentPlan;
  labRelatedDetails: Array<string>
  billingDetails: string
  isRescheduled: boolean
  //past appointment
  centerId: string
  patientId: string
  patientName: string
  consultantColourCode: string
  modifiedAt: Date
  createdAt: Date
  primaryPhoneNumber: string
  email: string
  centerColorCode: string
  allottedBed: any
  suggestedConsultationCharges: number
  finalInvoiceAmount: number
  isVIP: boolean
}

export enum AppointmentStatus {
  BOOKED = "BOOKED",
  CANCELLED = "CANCELLED",
  ONHOLD = "ONHOLD",
  WAITING_FOR_APPROVAL = "WAITING_FOR_APPROVAL",
  ARRIVED = "ARRIVED",
  ONGOING = "ONGOING",
  REVIEW = "REVIEW",
  NO_SHOW = "NO_SHOW",
  COMPLETED = "COMPLETED",
}

export enum PatientAppointmentType {
  FOLLOW_UP = "FOLLOW UP",
  NEW = "NEW",
  WALK_IN = "WALK IN",
}

export type IAppointmentResponse = {
  pastAppointments: Array<IAppointmentDetail>
  upcomingAppointments: Array<IAppointmentDetail>
}

export type IPastAppointment = {
  appointmentId: string
  id: string
  serviceType: string
  serviceName: string
  appointmentType: string
  patientAppointmentType: string
  location: string
  centerName: string
  primaryConsultant: string
  primaryConsultantName: string
  scheduleDate: Date
  scheduleTime: string
  comments: string
  uploads: Array<string>
  status: AppointmentStatus
  doctorNotes: Array<string>
  centerId: string
  patientId: string
  modifiedAt: Date
  createdAt: Date
}
